import SELECTORS from "./selectors";

/**
 * This is the infothek-wrapper custom Element which prevents
 * styles dropping from the outside into the infothek and vice
 * versa.
 */
class Infothek extends HTMLElement {
  /**
   *
   */
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  /**
   * Invoked each time the custom element is appended into a
   * document-connected element
   */
  connectedCallback() {
    this._addTemplateToShadowDom();
    Infothek.initClasses(this.shadowRoot);
  }

  /**
   * Queries the template and add it together with the infothek
   * stylesheet to the shadowDom
   */
  _addTemplateToShadowDom() {
    const link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("href", this.shadowRoot.host.dataset.cssPath);
    link.setAttribute("type", "text/css");
    this.shadowRoot.appendChild(link);

    const slot = this.querySelector("*");
    this.shadowRoot.appendChild(slot);
  }

  /**
   * Queries for js classes specified in the SELECTORS and
   * initialize a new related class
   *
   * @param {HTMLElement} rootSource
   */
  static initClasses(rootSource) {
    Object.keys(SELECTORS).forEach((key) => {
      rootSource.querySelectorAll(key).forEach((el) => {
        /* eslint-disable no-new */
        new SELECTORS[key](el);
      });
    });
  }
}

export default Infothek;
